import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {CourseDefinitionSearchModel} from "../course-definition-search.model";
import {
    CourseDefinitionSearchPageComponent
} from "../course-definition-search-page/course-definition-search-page.component";
import {CourseDefinitionEditPageComponent} from "../course-definition-edit-page/course-definition-edit-page.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CourseDefinitionSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-course-definition-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(CourseDefinitionSearchModel)
    ]
})
export class CourseDefinitionSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CourseDefinitionSearchModel> {
    constructor(model: CourseDefinitionSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = CourseDefinitionSearchPageComponent;
        this.extendedEditComponent = CourseDefinitionEditPageComponent;
    }
}
